import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import config from "../config";

/**
 * Fiori Launchpad-style sign-in.
 * - Subtle Horizon gradient backdrop
 * - Centered card with input fields and an "Emphasized" sign-in button
 */
const Login = ({ setEmail, setIsLoggedIn }) => {
  const [email, setEmailInput] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || "/p2p";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await fetch(
        config.api.login,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        },
      );
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("userEmail", email);
        localStorage.setItem("isLoggedIn", "true");
        setEmail(email);
        setIsLoggedIn(true);
        navigate(callbackUrl);
      } else {
        setError(data.message || "Login failed.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center font-sans px-4"
      style={{
        background:
          "linear-gradient(135deg, #1B2735 0%, #2C3E55 60%, #354A5F 100%)",
      }}
    >
      {/* Brand mark */}
      <div className="flex flex-row items-center justify-center gap-3 mb-8">
        <img
          src="/karini-logo.png"
          alt="Karini"
          className="h-9 w-auto object-contain bg-white rounded px-2 py-1"
        />
        <span className="text-white/70 text-base font-medium">on</span>
        <img
          src="/aws-logo.png"
          alt="AWS"
          className="h-9 w-auto object-contain"
        />
      </div>

      {/* Sign-in card */}
      <div className="w-full max-w-sm bg-white rounded-fiori-lg shadow-fiori-popover border border-fiori-border-light overflow-hidden">
        <div className="px-6 pt-6 pb-2">
          <h1 className="text-lg font-semibold text-fiori-text">Sign in</h1>
          <p className="text-xs text-fiori-text-secondary mt-1">
            ERP Exception Intelligent Automation
          </p>
        </div>

        <form className="px-6 pb-6 pt-4 space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="fiori-label" htmlFor="login-email">
              Email <span className="text-fiori-error">*</span>
            </label>
            <input
              id="login-email"
              type="email"
              placeholder="email@organization.com"
              className="fiori-input"
              required
              value={email}
              onChange={(e) => setEmailInput(e.target.value)}
            />
          </div>

          <div>
            <label className="fiori-label" htmlFor="login-password">
              Password <span className="text-fiori-error">*</span>
            </label>
            <input
              id="login-password"
              type="password"
              placeholder="Enter your password"
              className="fiori-input"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div
              className="fiori-status-error w-full justify-center py-2"
              role="alert"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            className="fiori-btn-emphasized w-full py-2"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>

      <p className="mt-6 text-xs text-white/60">
        © {new Date().getFullYear()} Karini AI on AWS
      </p>
    </div>
  );
};

export default Login;
